import React, { createContext, useState, useEffect } from "react";
import { loginURL, forgotPswURL, newPasswordURL } from "../Config/Url";
import { useHistory, useLocation } from "react-router-dom";
import axios from "axios";
import CryptoJS from "crypto-js";
import { roles } from "../Config/Roles";

export const AuthContext = createContext();

const AuthContextProvider = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { master, admin, support, owner, manager, cashier } = roles;
  const [validationMsg, setValidationMsg] = useState("");
  let init = localStorage.getItem("keepLogged");
  const [keepLogged, setKeepLogged] = useState(init === "true" ? true : false);

  const [state, setState] = useState({
    token: localStorage.getItem("token"),
    isAuth: localStorage.getItem("isAuth"),
    name: localStorage.getItem("name"),
    email: localStorage.getItem("email"),
    roleId: CryptoJS.AES.decrypt(
      localStorage.getItem("roleId") || "No-roleId",
      process.env.REACT_APP_HASH_KEY,
    ).toString(CryptoJS.enc.Utf8),
    userId: localStorage.getItem("userId"),
    tenantId: localStorage.getItem("tenantId"),
    multipleTenant: localStorage.getItem("multipleTenant"),
    tenantName: localStorage.getItem("tenantName"),
    useAccounting: localStorage.getItem("useAccounting"),
    //useAccounting: "false",
  });

  useEffect(() => {
    const decryptedToken = CryptoJS.AES.decrypt(
      localStorage.getItem("token") || "No-Token-Present",
      process.env.REACT_APP_HASH_KEY,
    ).toString(CryptoJS.enc.Utf8);

    localStorage.setItem("keepLogged", keepLogged);
    localStorage.setItem("tenantId", state.tenantId);
    axios.defaults.headers.common["Authorization"] = decryptedToken;
    axios.defaults.headers.common["X-TenantId"] =
      localStorage.getItem("tenantId");
  }, [keepLogged, state.tenantId, state.token]);

  async function login(username, password) {
    axios
      .post(loginURL, { username, password })
      .then((res) => {
        localStorage.setItem(
          "isAuth",
          CryptoJS.AES.encrypt(
            "true",
            process.env.REACT_APP_HASH_KEY,
          ).toString(),
        );

        localStorage.setItem(
          "token",
          CryptoJS.AES.encrypt(
            `Bearer ${res.data.user.token.accessToken}`,
            process.env.REACT_APP_HASH_KEY,
          ).toString(),
        );
        localStorage.setItem(
          "roleId",
          CryptoJS.AES.encrypt(
            `${res.data.user.roleId}`,
            process.env.REACT_APP_HASH_KEY,
          ).toString(),
        );
        localStorage.setItem("name", res.data.user.fullName);
        localStorage.setItem("email", res.data.user.email);
        localStorage.setItem("userId", res.data.user.id);
        localStorage.setItem("tenantId", res.data.user.tenantId);
        localStorage.setItem("multipleTenant", res.data.user.multipleTenant);
        localStorage.setItem("tenantName", res.data.user.tenantName);
        localStorage.setItem("useAccounting", res.data.user.useAccounting);
        setState({
          token: localStorage.getItem("token"),
          isAuth: localStorage.getItem("isAuth"),
          name: localStorage.getItem("name"),
          email: localStorage.getItem("email"),
          roleId: CryptoJS.AES.decrypt(
            localStorage.getItem("roleId"),
            process.env.REACT_APP_HASH_KEY,
          ).toString(CryptoJS.enc.Utf8),
          userId: localStorage.getItem("userId"),
          multipleTenant: localStorage.getItem("multipleTenant"),
          tenantId: localStorage.getItem("tenantId"),
          tenantName: localStorage.getItem("tenantName"),
          useAccounting: localStorage.getItem("useAccounting"),
        });

        axios.defaults.headers.common["Authorization"] = CryptoJS.AES.decrypt(
          localStorage.getItem("token"),
          process.env.REACT_APP_HASH_KEY,
        ).toString(CryptoJS.enc.Utf8);
        axios.defaults.headers.common["X-TenantId"] =
          localStorage.getItem("tenantId");

        switch (Number(res.data.user.roleId)) {
          case master:
          case admin:
          case support:
            history.push("/");
            break;
          case owner:
          case manager:
          case cashier:
            if (res.data.user.multipleTenant) {
              history.push("/switch-tenant");
            } else {
              history.push("/tenants/" + res.data.user.tenantId);
              //history.push("/dashboard");
            }
            break;
          case 7:
            history.push("/switch-tenant");
            break;
          default:
            history.push("/");
            break;
        }

        //history.push("/");
      })
      .catch((err) => {
        console.log("Error data:", err.response.data.message);
        setValidationMsg(err.response.data.message);
      });
  }

  const logout = () => {
    localStorage.setItem("isAuth", false);
    localStorage.setItem("token", null);
    localStorage.setItem("name", "");
    localStorage.setItem("email", "");
    localStorage.setItem("roleId", null);
    localStorage.setItem("tenantId", null);
    localStorage.setItem("multipleTenant", null);
    localStorage.setItem("useAccounting", false);
    localStorage.setItem("firstLogin", "No");
    localStorage.removeItem("AI_CHAT_ID");

    setKeepLogged(false);

    setState({
      token: null,
      isAuth: false,
      name: "",
    });

    axios.defaults.headers.common["Authorization"] = null;
    axios.defaults.headers.common["X-TenantId"] = null;
    window.location.href = "/login";
    //history.push("/login");
  };

  const setTenant = (tenantId) => {
    localStorage.setItem("tenantId", tenantId);
    setState({ ...state, tenantId });
    axios.defaults.headers.common["X-TenantId"] = tenantId;
  };
  const setTenantName = (tenantName) => {
    localStorage.setItem("tenantName", tenantName);
    setState({ ...state, tenantName });
  };

  const setUseAccounting = (inputValue) => {
    localStorage.setItem("useAccounting", inputValue);
    setState({ ...state, useAccounting: Boolean(inputValue) });
  };

  async function forgotPassword(username) {
    return axios
      .get(`${forgotPswURL}/${username}`)
      .then((res) => res)
      .catch((err) => err.response);
  }

  async function changePassword(token, newPassword, confirmPassword) {
    return axios
      .post(`${newPasswordURL}/${token}`, {
        newPassword,
        confirmPassword,
      })
      .then((res) => res)
      .catch((err) => err.response);
  }

  window.addEventListener("pagehide", function () {
    localStorage.setItem("keepLogged", keepLogged);
    localStorage.setItem("unloadTime", new Date().getTime());
  });

  window.onload = function () {
    var t0 = Number(localStorage.getItem("unloadTime"));
    if (isNaN(t0)) t0 = 0;
    var t1 = new Date().getTime();
    var duration = t1 - t0;
    if (duration > 3 * 1000) {
      if (localStorage.getItem("keepLogged") != "true") {
        if (
          location.pathname !== "/recovery" &&
          !location.pathname.includes("/public")
        ) {
          logout();
        }
      }
    }
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        setTenant,
        setTenantName,
        login,
        logout,
        forgotPassword,
        changePassword,
        keepLogged,
        setKeepLogged,
        validationMsg,
        setValidationMsg,
        setUseAccounting,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
